export default __webpack_public_path__ + "static/media/logo.a116d1b5.png";